import { render, staticRenderFns } from "./diagramChart.vue?vue&type=template&id=2fa43fb6&scoped=true"
import script from "./diagramChart.vue?vue&type=script&lang=js"
export * from "./diagramChart.vue?vue&type=script&lang=js"
import style0 from "./diagramChart.vue?vue&type=style&index=0&id=2fa43fb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa43fb6",
  null
  
)

export default component.exports